/**
 * @name MenuAdmin
 * @description Menú de acciones de administrador
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

// import { Environment } from '@config';
import { Icons, MUI, Typography } from '@styles';

class MenuAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  openHandler = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  closeHandler = () => {
    this.setState({ anchorEl: null });
  }

  // Redireccionar a la acción de administrador
  goToAction = (path) => {
    this.props.history.push(path);
  }

  render() {
    const { anchorEl } = this.state;
    const { appName, adminActions, customAdminActions } = this.props;

    return (
      <>
        {adminActions.length > 0 && (
          <>
            <Styled.BoxTopbarIcon onClick={this.openHandler}>
              <MUI.Tooltip title={i18n.t('Topbar.adminMenu')}>
                <Icons.MoreVert />
              </MUI.Tooltip>
            </Styled.BoxTopbarIcon>

            <Styled.Popover
              open={Boolean(anchorEl)}
              onClose={this.closeHandler}
              anchorEl={anchorEl}
            >
              <MUI.MenuHeader>
                <Styled.BoxHeader>
                  <Typography.Text>
                    {`${i18n.t('GenericMessages.adminOf')} ${appName}`}
                  </Typography.Text>
                </Styled.BoxHeader>
              </MUI.MenuHeader>

              <Styled.BoxAdminActions>
                {/* Menú Admin - Personalizado */}
                {customAdminActions ? (
                  customAdminActions
                ) : (
                  <>
                    {/* Menú Admin */}
                    {adminActions.map((action, i) => (
                      <MUI.MenuItem
                        key={i}
                        onClick={() => this.goToAction(action.route)}
                      >
                        <Typography.Text>
                          {action.label}
                        </Typography.Text>
                      </MUI.MenuItem>
                    ))}
                  </>
                )}
              </Styled.BoxAdminActions>
            </Styled.Popover>
          </>
        )}
      </>
    );
  }
}

MenuAdmin.propTypes = {
  // Nombre de la aplicación en la que se encuentra.
  appName: PropTypes.string,
  // Array de acciones de administrador.
  adminActions: PropTypes.array.isRequired,
  // Componente de React dentro del Popover.
  customAdminActions: PropTypes.node,
  // History router.
  history: PropTypes.object
};

// *************************************
// STYLED COMPONENTS             
// *************************************

const Styled = {};

Styled.BoxTopbarIcon = styled(MUI.ButtonText)`
  &.MuiButton-root{
    display: flex;
    min-width: 60px;
    width: 60px;
    height: 60px;
    padding: 12px;
    margin: 0;

    &:hover {
      text-decoration: none;
      background-color: ${(props) => props.theme.colors.greyHover};
      border-radius: 0%;
    }
  }
`;

Styled.BoxAdminActions = styled.div`
  max-height: 470px;
  overflow-y: auto;
  background: ${(props) => props.theme.colors.white};
  backface-visibility: hidden;
  scrollbar-width: thin !important; /* Scrollbar Firefox */
`;

Styled.BoxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

// *************************************
// GLOBAL STYLED COMPONENTS             
// *************************************

Styled.Popover = styled(MUI.Popover)`
  .MuiPopover-paper {
    min-width: 280px;
    max-height: 520px;
    max-width: 608px;
    left: auto !important;
    right: 16px !important;
    top: 60px !important;
    overflow-y: hidden;
    overflow-x: hidden;
  }
`;

export default MenuAdmin;